import { render, staticRenderFns } from "./DashboardOrm.vue?vue&type=template&id=53ccdcea&scoped=true"
import script from "./DashboardOrm.vue?vue&type=script&lang=js"
export * from "./DashboardOrm.vue?vue&type=script&lang=js"
import style0 from "./DashboardOrm.vue?vue&type=style&index=0&id=53ccdcea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ccdcea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ccdcea')) {
      api.createRecord('53ccdcea', component.options)
    } else {
      api.reload('53ccdcea', component.options)
    }
    module.hot.accept("./DashboardOrm.vue?vue&type=template&id=53ccdcea&scoped=true", function () {
      api.rerender('53ccdcea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardOrm.vue"
export default component.exports